/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCoolingRegimeGenusDtoCollectionResponseFromDiscriminatorValue, type CoolingRegimeGenusDtoCollectionResponse } from '../../../models/index.js';
// @ts-ignore
import { createODataErrorFromDiscriminatorValue, type ODataError } from '../../../models/oDataErrors/index.js';
// @ts-ignore
import { CountRequestBuilderRequestsMetadata, type CountRequestBuilder } from './count/index.js';
// @ts-ignore
import { type WithCoolingRegimeGenusItemRequestBuilder, WithCoolingRegimeGenusItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Provides operations to manage the coolingRegimeGenus property of the AapService.GenusDto entity.
 */
export interface CoolingRegimeGenusRequestBuilder extends BaseRequestBuilder<CoolingRegimeGenusRequestBuilder> {
    /**
     * Provides operations to count the resources in the collection.
     */
    get count(): CountRequestBuilder;
    /**
     * Provides operations to manage the coolingRegimeGenus property of the AapService.GenusDto entity.
     * @param coolingRegimeGenusId The unique identifier of CoolingRegimeGenusDto
     * @returns {WithCoolingRegimeGenusItemRequestBuilder}
     */
     byCoolingRegimeGenusId(coolingRegimeGenusId: number) : WithCoolingRegimeGenusItemRequestBuilder;
    /**
     * Get coolingRegimeGenus from GenusOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CoolingRegimeGenusDtoCollectionResponse>}
     * @throws {ODataError} error when the service returns a 4XX or 5XX status code
     */
     get(requestConfiguration?: RequestConfiguration<CoolingRegimeGenusRequestBuilderGetQueryParameters> | undefined) : Promise<CoolingRegimeGenusDtoCollectionResponse | undefined>;
    /**
     * Get coolingRegimeGenus from GenusOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CoolingRegimeGenusRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Get coolingRegimeGenus from GenusOverview
 */
export interface CoolingRegimeGenusRequestBuilderGetQueryParameters {
    /**
     * Include count of items
     */
    count?: boolean;
    /**
     * Expand related entities
     */
    expand?: string[];
    /**
     * Filter items by property values
     */
    filter?: string;
    /**
     * Order items by property values
     */
    orderby?: string[];
    /**
     * Search items by search phrases
     */
    search?: string;
    /**
     * Select properties to be returned
     */
    select?: string[];
    /**
     * Skip the first n items
     */
    skip?: number;
    /**
     * Show only the first n items
     */
    top?: number;
}
/**
 * Uri template for the request builder.
 */
export const CoolingRegimeGenusRequestBuilderUriTemplate = "{+baseurl}/GenusOverview/{genusId}/coolingRegimeGenus{?%24count,%24expand,%24filter,%24orderby,%24search,%24select,%24skip,%24top}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const CoolingRegimeGenusRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "count": "%24count",
    "expand": "%24expand",
    "filter": "%24filter",
    "orderby": "%24orderby",
    "search": "%24search",
    "select": "%24select",
    "skip": "%24skip",
    "top": "%24top",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CoolingRegimeGenusRequestBuilderNavigationMetadata: Record<Exclude<keyof CoolingRegimeGenusRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCoolingRegimeGenusId: {
        requestsMetadata: WithCoolingRegimeGenusItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["coolingRegimeGenusId"],
    },
    count: {
        requestsMetadata: CountRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CoolingRegimeGenusRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CoolingRegimeGenusRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            XXX: createODataErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCoolingRegimeGenusDtoCollectionResponseFromDiscriminatorValue,
        queryParametersMapper: CoolingRegimeGenusRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
